import { render, staticRenderFns } from "./LtkDiscoverFeed.vue?vue&type=template&id=fb40f45e"
import script from "./LtkDiscoverFeed.vue?vue&type=script&setup=true&lang=ts"
export * from "./LtkDiscoverFeed.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LtkFeedItem: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/Ltk/LtkFeedItem.vue').default,LtkList: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/Ltk/LtkList.vue').default})
